import { render, staticRenderFns } from "./PillColumn.vue?vue&type=template&id=130d6729&"
import script from "./PillColumn.vue?vue&type=script&lang=js&"
export * from "./PillColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports